export const afterDecimal = (num: number) => {
    if (Number.isInteger(num)) {
        return 0;
    }

    return num.toString().split(".")[1].length;
};
